
import React from "react";
import { useTranslation } from 'react-i18next';

interface PointDisplayProps {
  currentPoint: string;
  currentAttempt: number;
  maxAttempts: number;
  distance: string;
  isChippingTest: boolean;
  getFormattedPoint: (point: string) => string;
  currentLevel?: 1 | 2 | 3;
}

const PointDisplay: React.FC<PointDisplayProps> = ({
  currentPoint,
  currentAttempt,
  maxAttempts,
  distance,
  isChippingTest,
  getFormattedPoint,
  currentLevel = 3,
}) => {
  const { t } = useTranslation('training');
  
  // Determine the display distance
  const displayDistance = distance || getFormattedPoint(currentPoint);

  return (
    <div className="text-center mb-4">
      <h3 className="text-xl font-semibold mb-1">
        {t('interface.currentPoint')}: {currentPoint} - {t('interface.attempt')} {currentAttempt + 1}/{maxAttempts}
      </h3>
      <p className="text-green-600 font-medium">
        {t('interface.distance')}: {displayDistance}
      </p>
    </div>
  );
};

export default PointDisplay;
